module.exports = __webpack_public_path__ + "static/media/image1.fcfe8fdf.jpg";